export default __webpack_public_path__ + "static/media/icon_chevron_hub_right.6dd892fe.svg";